const reducer = state => ({
  ...state,
  giftCardToRemove: null,
  waiting: false,
});

export default reducer;
